export const getExpiryDateFromSubmittedFormValues = (expiryDate: string) => ({
  month: +expiryDate.slice(0, 2),
  year: +expiryDate.slice(2),
});
